// ----------------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//        Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------------
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class ConsumerService {
    register(service) {
        return service.addConsumerService(this);
    }
    constructor(name, instrumentService){
        _define_property(this, "name", void 0);
        _define_property(this, "action", void 0);
        _define_property(this, "buffer", void 0);
        _define_property(this, "aggregation", void 0);
        _define_property(this, "instrumentService", void 0);
        this.name = name;
        if (instrumentService) {
            this.instrumentService = instrumentService;
            this.register(instrumentService);
        }
    }
}
